// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KLG0H","col":"styles_col__3pmbX"};